import { h, app } from 'hyperapp';
import JSZip from './jszip';
import { tnOnCreate, createTnOnRemove, Image, TextInput, TextArea, RadioButton, ImageOption, Checkbox, Select, Range, Echo, Button, MenuButton, InputGroup, Grid, FileInput, File, Control, MiniControl, ColorInput, Modal } from './front_component';
import { Imagecrop, preparePicture, preparePictureAsync, prepareText, prepareTextAsync } from './imagecrop';


const br = {nodeName:'br', attributes:{}, children:[]}

const _Tv = (x) => {
  x = _T(x)
  if (typeof x != 'string') return x

  const lines = x.split('\n')
  if (lines.length == 1) return lines[0]
  
  return lines.reduce((cur, line) => {
    return (cur.length == 0) ? [line] : [...cur, br, line]
  }, [])
}

const _T = (x) => {
  if (typeof x == 'undefined' || x === null) return null
  if (catalog.hasOwnProperty(x)) {
    return catalog[x]
  } else {
    console.log('TO TRANSLATE: ', x);
    return x;
  }
}

function sprintf(format) {
  var args = arguments;
  var offset = 1;
  return format.replace(/%([0-9]\$)?([^0-9])/g, function (match, f1, f2) {
    if (f2 == '%') {
      return '%';
    } else if (f2 == 's') {
      if (! f1) {
        return args[offset++];
      } else {
        return args[f1.slice(0, 1)];
      }
    }
  });
}


const scrollTo = (idOrElem) => {
  const pos = document.documentElement.scrollTop || document.body.scrollTop;
  const r = ((typeof idOrElem == 'string') ? document.getElementById(idOrElem) : idOrElem).getBoundingClientRect()
  const posBot = r.top + pos - 100
  const posTop = r.top + pos - 150
  if (posTop > pos) {
    if (behavior.smoothScroll) {
      const diff = Math.max((posTop - pos) / 8, 4)
      window.requestAnimationFrame(() => scrollTo(idOrElem))
      window.scrollTo(0, pos + diff)
    } else {
      window.scrollTo(0, posTop)
    }
  } else if (posBot < pos) {
    if (behavior.smoothScroll) {
      const diff = Math.max((pos - posBot) / 8, 4)
      window.requestAnimationFrame(() => scrollTo(idOrElem))
      window.scrollTo(0, pos - diff)
    } else {
      window.scrollTo(0, posBot)
    }
  }
}

const showInvalidItem = (isDetail) => {
  let elem = null;
  if (isDetail && (elem = document.querySelector('.rd-belongs-hnavigator.rd-is-invalid'))) {
    scrollTo(elem)
  } else if (isDetail && (elem = document.querySelector('.rd-Button.rd-belongs-wnavbase'))) {
    scrollTo(elem)
  } else if (! isDetail && (elem = document.querySelector('.rd-belongs-attr.rd-is-invalid'))) {
    scrollTo(elem)
  }
}

const findByProp = (name, val, arr) => {
  const len = arr.length
  for (let i = 0; i < len; i++) {
    if (arr[i][name] == val) return arr[i]
  }
  return undefined
}

const findIndexByProp = (name, val, arr) => {
  const len = arr.length
  for (let i = 0; i < len; i++) {
    if (arr[i][name] == val) return i
  }
  return -1
}

const satisfied = (set, specs) => {
  for (let prop in specs) {
    if (specs[prop] != set.hasOwnProperty(prop)) return false
  }
  return true
}

const extend = (set, specs) => {
  const copy = {...set}
  for (let prop in specs) {
    if (specs[prop]) {
      copy[prop] = true
    } else {
      delete copy[prop]
    }
  }
  return copy
}

const exclude = (set, prop) => {
  const copy = {...set}
  delete copy[prop]
  return copy
}

const branchNo = (name, sep) => {
  const off = name.lastIndexOf(sep)
  const fragment = name.slice(off + 1)
  return parseInt(fragment)
}

const replaceElement = (arr, idx, value) => {
  const arr2 = [...arr]
  arr2[idx] = value
  return arr2
}

const indexOf = (e, lis) => {
  const len = lis.length
  for (let i = 0; i < len; i++) {
    if (lis[i] == e) return i
  }
  return -1
}

const reduceHash = (f, cur, hash) => {
  for (let key in hash) {
    cur = f(cur, key, hash[key])
  }
  return cur
}

const includesExt = (filename, exts) => {
  const ext = filename.split('.').at(-1).toLowerCase()
  const es = exts.split(',').map(e => e.toLowerCase().trim())
  return es.includes(ext)
}


const BgSelector = (
    {
      item, 
      value, 
      message, 
      onstart
    }) => {
  // NOTE: 背景は常に表示される。たとえ全ての選択肢がdisabledでも。
  const selectedOption = (value) ? findByProp('id', value, item.options) : null
  return (
    <Control id={item.id} name={item.name} note={item.note} message={message} onremove={tnOnRemove}>
      <InputGroup gutter="mini" valign="top">
        {value ? (
          <Image src={selectedOption.sample || noimageUrl} scaling="contain" xclass="rd-for-bgselector" />
        ) : null}
        {value ? (
          <Echo value={selectedOption.name} name={item.name} glue="" />
        ) : null}
        <Button onclick={onstart} data-item={item.id}>{_T('Select background')}</Button>
      </InputGroup>
    </Control>
  )
}

const Selector = (
    {
      item, 
      value, 
      labels, 
      message, 
      onchange
    }) => {
  if (item.options.every(o => !satisfied(labels, o.depends))) {
    // 全選択肢がdisabledなので項目自体を非表示にする。
    return null
  }
  if (item.uiType == 'dropdown') {
    const accessOption = (prop, o) => {
      if (prop == 'value') return o.id
      else if (prop == 'name') return o.name
      else if (prop == 'disabled') return !satisfied(labels, o.depends)
    }
    return (
      <Control id={item.id} name={item.name} note={item.note} message={message} onremove={tnOnRemove}>
        <Select name={`Selector-${item.id}`} options={item.options} value={value} invalid={!!message} onchange={onchange} accessOption={accessOption}></Select>
      </Control>
    )
  } else {
    return (
      <Control itemId={item.id} name={item.name} note={item.note} message={message} onremove={tnOnRemove}>
        <InputGroup gutter="mini">
          {item.options.map((o, i) => (
            <RadioButton index={i} name={`Selector-${item.id}`} value={o.id} checked={o.id == value} invalid={!!message} disabled={!satisfied(labels, o.depends)} onchange={onchange}>
              {o.name}
            </RadioButton>
          ))}
        </InputGroup>
      </Control>
    )
  }
}

const Picture = (
    {
      item, 
      value, 
      labels, 
      message, 
      onchange, 
      ondrop, 
      onclear, 
      onadjust
    }) => {
  if (!satisfied(labels, item.depends)) {
    // 項目自体を非表示にする。
    return null
  }
  return (
    <Control id={item.id} name={item.name} note={item.note} message={message} onremove={tnOnRemove}>
      <InputGroup gutter="mini" valign="top">
        {!value ? (
          <FileInput name={`Picture-${item.id}`} extensions={item.allowedExts} onchange={onchange} multiple={false} invalid={!!message} ondrop={ondrop}>{_T('Drop a file or click')}</FileInput>
        ) : null}
        {value ? (
          <File index={item.id} key={value.url} url={value.url} name={value.name} loading={!value.url} ondelete={onclear} tnOnRemove={tnOnRemove} />
        ) : null}
        {value ? (
          <Button onclick={onadjust} data-item={item.id}>{_T('Adjust position and scale')}</Button>
        ) : null}
      </InputGroup>
    </Control>
  )
}

const accessTextSize = (prop, o) => {
  if (prop == 'value') return o.value
  else if (prop == 'name') return o.name
  else if (prop == 'disabled') return false
}
const Text = (
    {
      item, 
      value, 
      labels, 
      message, 
      ontextinput, 
      ontextblur, 
      onsizechange, 
      oncolorchange, 
      sizes,  // {name,value}[]
    }
) => {
  if (!satisfied(labels, item.depends)) {
    // 項目自体を非表示にする。
    return null
  }
  const colors = item.colors.split(',').map(c => c.trim())
  return (
    <Control id={item.id} name={item.name} note={item.note} message={message} onremove={tnOnRemove}>
      <TextArea size="mini" name={`Text-${item.id}-text`} value={value.text} invalid={!!message} oninput={ontextinput} onblur={ontextblur} />
      <MiniControl name={_T('Text size')}>
        <Select name={`Text-${item.id}-size`} options={sizes} value={value.size} invalid={false} onchange={onsizechange} accessOption={accessTextSize} />
      </MiniControl>
      <MiniControl name={_T('Color')}>
        <ColorInput name={`Text-${item.id}-color`} value={value.color} oncolorchange={oncolorchange} swatches={colors} position="top-middle" />
      </MiniControl>
    </Control>
  )
}

const BgImageModal = (
    {
      open, 
      onclose, 
      onchange, 
      item, 
      value, 
      labels
    }) => {
  const controls = [
    <MenuButton type="normal" onclick={onclose} title={_T('Close')} icon="no-alt" />
  ]
  const closeModalOnChange = (ev) => {
    onchange(ev)
    window.setTimeout(() => {
      onclose()
    }, 500)
  }
  return (
    <Modal open={open} id="rd-bgimage-modal" tnOnRemove={tnOnRemove} title={_T('Background Selection')} controls={controls} scrollable>
      <Grid gutter="mini">
        {item ? (
          item.options.map((o, i) => {
            return (
              <ImageOption index={i} name={`BgSelector-${item.id}`} value={o.id} checked={o.id == value} disabled={!satisfied(labels, o.depends)} onchange={closeModalOnChange} image={o.sample || noimageUrl} />
            )
          })
        ) : []}
      </Grid>
    </Modal>
  )
}

const CropModal = (
    {
      open, 
      item, 
      oncancel, 
      onapply, 
      value
    }) => {
  if (! item || ! value) return null
  const name = item.id
  const imageUrl = value.url
  const x = value.x
  const y = value.y
  const scale = value.scale
  const offscreenId = 'rd-offscreen'
  const [vdom, commit] = Imagecrop({name, imageUrl, x, y, scale, oncropend:onapply, paperWidth, paperHeight, frame:item, offscreenId})
  const actions = [
    <Button onclick={oncancel}>{_T('Cancel')}</Button>, 
    <Button type="primary" onclick={commit}>{_T('Apply')}</Button>
  ]
  return (
    <Modal open={open} id="rd-crop-modal" tnOnRemove={tnOnRemove} title={_T('Adjustment of Position and Scale')} actions={actions}>
      {vdom}
    </Modal>
  )
}

const MenuModal = (
    {
      open, 
      title, 
      oninput, 
      onblur, 
      ondownload, 
      onsave, 
      onclose, 
      downloadDisabled
    }
) => {
  const controls = [
    <MenuButton type="normal" onclick={onclose} title={_T('Close')} icon="no-alt" />
  ]
  return (
    <Modal open={open} id="rd-menu-modal" tnOnRemove={tnOnRemove} title={_T('Menu')} controls={controls} size="mini">
      <Grid gutter="mini">
        <TextInput size="full" value={title} oninput={oninput} name="title" onblur={onblur} />
        <Button size="full" type="primary" onclick={onsave}>{_T('Save')}</Button>
        <Button size="full" type="normal" disabled={downloadDisabled} onclick={ondownload}>{_T('Excel for inputting')}</Button>
      </Grid>
    </Modal>
  )
}

const Model = ({pages, pageIndex, onprev, onnext}) => {
  const hasPrev = (pageIndex > 0)
  const hasNext = (pageIndex + 1 < pages.length)
  const hasRight = (pageIndex < pages.length)
  const hasLeft = (pageIndex > 1)
  const status = (hasLeft && hasRight) ? sprintf(_T('%s..%s of %s pages'), pageIndex, pageIndex + 1, pages.length)
    : (hasLeft) ? sprintf(_T('%s of %s pages'), pageIndex, pages.length)
    : (hasRight) ? sprintf(_T('%s of %s pages'), pageIndex + 1, pages.length) 
    : ''
  return (
    <div class={`rd-Model`} key="model">
      <div class="rd--page rd-page-dummy" key="dummy-1">
        <img class="rd--placeholder" src={transparentUrl} />
      </div>
      <div class="rd--page rd-page-dummy" key="dummy-2">
        <img class="rd--placeholder" src={transparentUrl} />
      </div>
      {pages.map((page, i) => {
        const id = `page-${page.order}`
        const even = i % 2 == 0
        const flipped = (even) ? pageIndex > i : pageIndex < i
        const zIndex = (even) ? 100 - i : 50 + i
        return (
          <div class={`rd--page rd-index-${even ? 'even' : 'odd'} ${flipped ? 'rd-is-flipped' : ''} ${(!hasPrev && !hasNext) ? 'rd-is-single' : ''}`} style={{zIndex}} key={id} id={id}>
            <img class="rd--placeholder" src={transparentUrl} />
            {page.background ? (<img class="rd--background" src={page.background} />) : null}
            {page.picture ? (<img class="rd--picture" src={page.picture} />) : null}
            {page.content ? (<img class="rd--content" src={page.content} />) : null}
            {page.text ? (<img class="rd--picture" src={page.text} />) : null}
          </div>
        )
      })}
      <div class="rd--controls" key="controls">
        <Button type="normal" onclick={onprev} xclass="rd-belongs-Model rd-for-prev" disabled={! hasPrev}><span>{_T('Previous Page')}</span></Button>
        <div class="rd--status">{status}</div>
        <Button type="normal" onclick={onnext} xclass="rd-belongs-Model rd-for-next" disabled={! hasNext}><span>{_T('Next Page')}</span></Button>
      </div>
    </div>
  )
}

const actions = {
  onInput2: (ev) => (state, actions) => {
    const [_type, itemId, prop] = ev.currentTarget.name.split('-')
    const value = {...state.input[itemId], [prop]:ev.currentTarget.value}
    const input = {...state.input, [itemId]:value}
    return {...state, input}
  }, 
  onBlur2: (ev) => (state, actions) => {
    const [_type, itemId, prop] = ev.currentTarget.name.split('-')
    const item = findByProp('id', itemId, state.template.items)
    if (item.type == 'Text') {
      prepareText({offscreenId: 'rd-offscreen', name:item.id, value:state.input[item.id], point:item}, actions.onPrepareTextK)
    } else {
      reserveProcess(actions.onProcess)
    }
  }, 
  onInputT: (ev) => (state, actions) => {
    const name = ev.currentTarget.name
    return {...state, [name]:ev.currentTarget.value}
  }, 
  onBlurT: (ev) => (state, actions) => {
    const name = ev.currentTarget.name
    const value = ev.currentTarget.value || _T('Untitled design')
    return {...state, [name]:value}
  }, 
  onChange: (ev) => (state, actions) => {
    const [_type, itemId] = ev.currentTarget.name.split('-')
    const input = {...state.input, [itemId]:ev.currentTarget.value}
    reserveProcess(actions.onProcess)
    return {...state, input}
  }, 
  onChange2: (ev) => (state, actions) => {
    const [_type, itemId, prop] = ev.currentTarget.name.split('-')
    const value = {...state.input[itemId], [prop]:ev.currentTarget.value}
    const input = {...state.input, [itemId]:value}
    const item = findByProp('id', itemId, state.template.items)
    if (item.type == 'Text') {
      prepareText({offscreenId: 'rd-offscreen', name:item.id, value, point:item}, actions.onPrepareTextK)
    } else {
      reserveProcess(actions.onProcess)
    }
    return {...state, input}
  }, 
  onColorChange2: ({name, value:rawValue}) => (state, actions) => {
    const [_type, itemId, prop] = name.split('-')
    const value = {...state.input[itemId], [prop]:rawValue}
    const input = {...state.input, [itemId]:value}
    const item = findByProp('id', itemId, state.template.items)
    if (item.type == 'Text') {
      prepareText({offscreenId: 'rd-offscreen', name:item.id, value, point:item}, actions.onPrepareTextK)
    } else {
      reserveProcess(actions.onProcess)
    }
    return {...state, input}
  }, 
  onBgImageModalActivate: (ev) => (state, actions) => {
    const itemId = ev.currentTarget.dataset.item
    return {...state, bgImageModalItem:itemId}
  }, 
  onBgImageModalClose: () => (state, actions) => {
    return {...state, bgImageModalItem:null}
  }, 
  onFileChange: (ev) => (state, actions) => {
    const files = ev.currentTarget.files
    if (! files || files.length == 0) {
      console.log('NO FILE onFileChange')
      return null
    }
    const file = files[0]
    const [_type, itemId] = ev.currentTarget.name.split('-')
    const item = findByProp('id', itemId, state.template.items)
    if (! includesExt(file.name, item.allowedExts)) {
      window.alert(_T('Drop an image file.'))
      return null
    }
    if (state.input[itemId]) {
      const oldValue = state.input[itemId]
      window.URL.revokeObjectURL(oldValue.url)
      if (oldValue.preparedUrl) {
        window.URL.revokeObjectURL(oldValue.preparedUrl)
      }
    }
    const url = window.URL.createObjectURL(file)
    const value = {url, name:file.name, scale:1, x:0, y:0, preparedUrl:null}
    preparePicture({offscreenId:'rd-offscreen', name:itemId, imageUrl:value.url, x:value.x, y:value.y, scale:value.scale, frame:item}, actions.onPreparePictureK)
    const input = {...state.input, [itemId]:value}
    return {...state, input}
  }, 
  onFileDrop: (ev) => (state, actions) => {
    const files = ev.dataTransfer.files
    if (! files || files.length == 0) {
      console.log('NO FILE onFileDrop', files)
      return null
    }
    const file = files[0]
    const [_type, itemId] = ev.currentTarget.dataset.name.split('-')
    const item = findByProp('id', itemId, state.template.items)
    if (! includesExt(file.name, item.allowedExts)) {
      window.alert(_T('Drop an image file.'))
      return null
    }
    if (state.input[itemId]) {
      const oldValue = state.input[itemId]
      window.URL.revokeObjectURL(oldValue.url)
      if (oldValue.preparedUrl) {
        window.URL.revokeObjectURL(oldValue.preparedUrl)
      }
    }
    const url = window.URL.createObjectURL(file)
    const value = {url, name:file.name, scale:1, x:0, y:0, preparedUrl:null}
    preparePicture({offscreenId:'rd-offscreen', name:itemId, imageUrl:value.url, x:value.x, y:value.y, scale:value.scale, frame:item}, actions.onPreparePictureK)
    const input = {...state.input, [itemId]:value}
    return {...state, input}
  }, 
  onFileClear: (ev) => (state, actions) => {
    const itemId = ev.currentTarget.dataset.index
    if (state.input[itemId]) {
      const oldValue = state.input[itemId]
      window.URL.revokeObjectURL(oldValue.url)
      if (oldValue.preparedUrl) {
        window.URL.revokeObjectURL(oldValue.preparedUrl)
      }
    }
    const input = exclude(state.input, itemId)
    reserveProcess(actions.onProcess)
    return {...state, input}
  }, 
  onFileAdjust: (ev) => (state, actions) => {
    const itemId = ev.currentTarget.dataset.item
    return {...state, cropModalItem:itemId}
  }, 
  onFileCancel: (ev) => (state, actions) => {
    return {...state, cropModalItem:null}
  }, 
  onPreparePictureK: ({name, x, y, scale, blob}) => (state, actions) => {
    const item = findByProp("id", name, state.template.items)
    const value0 = state.input[name]
    const url = window.URL.createObjectURL(blob)
    const value = {...value0, preparedUrl:url, x, y, scale}
    const input = {...state.input, [item.id]:value}
    if (value0.preparedUrl) {
      window.URL.revokeObjectURL(value0.preparedUrl)
    }
    window.setTimeout(() => {
      actions.onFileCancel()
    }, 400)
    reserveProcess(actions.onProcess)
    return {...state, input}
  }, 
  onPrepareTextK: ({name, blob}) => (state, actions) => {
    const item = findByProp('id', name, state.template.items)
    const value0 = state.input[name]
    const url = window.URL.createObjectURL(blob)
    const value = {...value0, preparedUrl:url}
    const input = {...state.input, [item.id]:value}
    if (value0.preparedUrl) {
      window.URL.revokeObjectURL(value0.preparedUrl)
    }
    reserveProcess(actions.onProcess)
    return {...state, input}
  }, 
  onProcess: () => (state, actions) => {
    const {input, labels, pages} = process(state.input, state.template)
    return {...state, input, labels, pages}
  }, 
  onNextPage: () => (state, actions) => {
    const pageIndex = state.pageIndex + 2
    return {...state, pageIndex}
  }, 
  onPrevPage: () => (state, actions) => {
    const pageIndex = state.pageIndex - 2
    return {...state, pageIndex}
  }, 
  onSave: () => (state, actions) => {
    saveDesign(state.template, state.input, state.title)
    return null
  }, 
  onOpen: (ev) => (state, actions) => {
    const files = (ev.currentTarget.files || (ev.dataTransfer && ev.dataTransfer.files))
    if (ev.dataTransfer) {
      ev.preventDefault()
    }
    if (! files || files.length == 0) {
      console.log('NO FILE onOpen', files)
      return null
    }
    const file = files[0]
    const fragments = file.name.split('.')
    const ext = fragments.pop()
    const title = fragments.join('.')
    if (ext != "zip") {
      window.alert(_T('Drop a zip file.'))
      return null
    }
    openDesign(file, title).then(actions.onOpenK).catch(() => actions.onOpenFailure(_T('Could not open the file.')))
    return null
  }, 
  onOpenK: ({template, input:input0, title}) => (state, actions) => {
    const {input, labels, pages} = process(input0, template)
    if (state.template) {
      closeDesign(state.template, state.input)
    }
    return {...state, template, input, labels, pages, title}
  }, 
  onOpenFailure: (message) => (state, actions) => {
    window.alert(_T('An error has occurred. ') + message)
  }, 
  onStart: (ev) => (state, actions) => {
    const templateId = ev.currentTarget.dataset.template
    startDesign(templateId).then(actions.onOpenK).catch(() => actions.onOpenFailure(_T('Could not load template.')))
  }, 
  onClose: (ev) => (state, actions) => {
    if (window.confirm(_T('Close the design you are creating. Are you sure?'))) {
      closeDesign(state.template, state.input)
      return {...state, template:null, input:null, labels:null, pages:null, pageIndex:0}
    }
  }, 
  onDownload: (ev) => (state, actions) => {
    const url = state.template.general.excel
    const a = document.createElement('a')
    a.href = url
    a.download = state.title + _T('.xlsx')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }, 
  onMenuOpen: (ev) => (state, actions) => {
    return {...state, menuOpen:true}
  }, 
  onMenuClose: (ev) => (state, actions) => {
    return {...state, menuOpen:false}
  }
}

const updatePage = (page, prop, value, order) => {
  if (typeof page != 'object') page = {}
  return {...page, order, [prop]:value}
}
const process = (input0, template) => {  // => {input, labels, pages}
  // (input) => {labels, pages, background}
  // page := {order, background, content, picture, text}
  // 稀な状況で、process()がinputを変更する場合がある。
  const {labels, pages:pages0, input, background} = template.items.reduce((cur, item, i) => {
    return processTable[item.type](cur, item, i)
  }, {labels:{}, pages:{}, input:input0, background:whiteUrl})

  const pages = []
  for (let p in pages0) {
    pages.push({...pages0[p], background})
  }
  pages.sort((p0, p1) => ((+p0.order) - (+p1.order)))
  return {labels, pages, input}
}
const processTable = {
  BgSelector: (cur, item, i) => {
    if (! cur.input.hasOwnProperty(item.id)) {
      // not selected
      return cur
    }
    const selectedOption = findByProp("id", cur.input[item.id], item.options)
    if (! satisfied(cur.labels, selectedOption.depends)) {
      // option disabled
      const input = exclude(cur.input, item.id)
      return {...cur, input}
    }
    const labels = extend(cur.labels, selectedOption.labels)
    const background = selectedOption.layer
    return {...cur, labels, background}
  }, 
  Selector: (cur, item, i) => {
    if (! cur.input.hasOwnProperty(item.id)) {
      // not selected
      return cur
    }
    const selectedOption = findByProp("id", cur.input[item.id], item.options)
    if (! satisfied(cur.labels, selectedOption.depends)) {
      // option disabled
      const input = exclude(cur.input, item.id)
      return {...cur, input}
    }
    const labels = extend(cur.labels, selectedOption.labels)
    if (typeof item.pageOrder != 'number') {
      // page not specified
      return {...cur, labels}
    }
    const page = updatePage(cur.pages[item.pageOrder], 'content', selectedOption.layer, item.pageOrder)
    const pages = {...cur.pages, [item.pageOrder]:page}
    return {...cur, labels, pages}
  }, 
  Fixed: (cur, item, i) => {
    if (! satisfied(cur.labels, item.depends)) {
      // fixed disabled
      return cur
    }
    if (typeof item.pageOrder != 'number') {
      // page not specified
      return cur
    }
    const page = updatePage(cur.pages[item.pageOrder], 'content', item.layer, item.pageOrder)
    const pages = {...cur.pages, [item.pageOrder]:page}
    return {...cur, pages}
  }, 
  Picture: (cur, item, i) => {
    if (! cur.input.hasOwnProperty(item.id)) {
      // not selected
      return cur
    }
    if (! satisfied(cur.labels, item.depends)) {
      // picture disabled
      return cur
    }
    if (typeof item.pageOrder != 'number') {
      // page not specified
      return cur
    }
    if (! cur.input[item.id].preparedUrl) {
      // no image prepared
      return cur
    }
    const page = updatePage(cur.pages[item.pageOrder], 'picture', cur.input[item.id].preparedUrl, item.pageOrder)
    const pages = {...cur.pages, [item.pageOrder]:page}
    return {...cur, pages}
  }, 
  Text: (cur, item, i) => {
    if (! satisfied(cur.labels, item.depends)) {
      // text disabled
      return cur
    }
    if (typeof item.pageOrder != 'number') {
      // page not specified
      return cur
    }
    if (! cur.input[item.id].preparedUrl) {
      // no image prepared
      return cur
    }
    const page = updatePage(cur.pages[item.pageOrder], 'text', cur.input[item.id].preparedUrl, item.pageOrder)
    const pages = {...cur.pages, [item.pageOrder]:page}
    return {...cur, pages}
  }
}
const reserveProcess = (onprocess) => {
  window.requestAnimationFrame(() => {
    onprocess()
  })
}

const saveDesign = async (template, input0, title) => {
  // input.json, externals/, meta.json
  const zip = new JSZip()
  const exts = zip.folder('externals')
  const meta = {template: template.id, revision: template.revision}
  const input = {}
  let extId = 1
  for (let p in input0) {
    const item = findByProp("id", p, template.items)
    const value = typeof input0[p] == "object" ? {...input0[p]} : input0[p]
    switch (item.type) {
      case 'Picture': 
        if (value.url) {
          const blob = await fetch(value.url).then(r => r.blob())
          value.url = `external:${extId}`
          exts.file(extId, blob)
          extId++
        }
        if (value.preparedUrl) {
          const blob = await fetch(value.preparedUrl).then(r => r.blob())
          value.preparedUrl = `external:${extId}`
          exts.file(extId, blob)
          extId++
        }
        break
      case 'Text': 
        if (value.preparedUrl) {
          const blob = await fetch(value.preparedUrl).then(r => r.blob())
          value.preparedUrl = `external:${extId}`
          exts.file(extId, blob)
          extId++
        }
        break
    }
    input[p] = value
  }
  zip.file('meta.json', JSON.stringify(meta))
  zip.file('input.json', JSON.stringify(input))
  const zipBlob = await zip.generateAsync({type:'blob', compression:"DEFLATE"})
  const zipUrl = window.URL.createObjectURL(zipBlob)
  const a = document.createElement('a')
  a.href = zipUrl
  a.download = `${title}.zip`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(zipUrl)
}

const closeDesign = (template, input) => {
  for (let p in input) {
    const item = findByProp('id', p, template.items)
    const value = input[p]
    switch (item.type) {
      case 'Picture': 
        if (value.url) {
          window.URL.revokeObjectURL(value.url)
        }
        if (value.preparedUrl) {
          window.URL.revokeObjectURL(value.preparedUrl)
        }
        break
      case 'Text': 
        if (value.preparedUrl) {
          window.URL.revokeObjectURL(value.preparedUrl)
        }
        break
    }
  }
}

const loadTemplate = async (templateId, revision) => {
  const url = refUrl.replace('placeholder1', templateId).replace('placeholder2', revision)
  const {template} = await fetch(url, {credentials: "include"}).then(r => r.json())
  return template
}

const startDesign = async (templateId) => {
  const template = await loadTemplate(templateId, 0)
  const title = _T('Untitled design')
  const input = {}
  for (let item of template.items) {
    switch (item.type) {
      case 'Text': 
        {
          const initialColor = item.colors.split(',')[0].trim();
          const value = {text:item.initialText, size:item.initialSize, color:initialColor}
          const {name:_name, blob} = await prepareTextAsync({offscreenId:'rd-offscreen', name:'', value, point:item})
          value.preparedUrl = window.URL.createObjectURL(blob)
          input[item.id] = value
        }
        break
      case 'Picture': 
        if (item.initial) {
          const i = item.initial.lastIndexOf('.')
          const ext = item.initial.slice(i)
          const value = {url:item.initial, name:_T('Default image') + ext, scale:1, x:0, y:0, preparedUrl:null}
          const {blob, ..._unused} = await preparePictureAsync({offscreenId:'rd-offscreen', name:'', imageUrl:value.url, x:value.x, y:value.y, scale:value.scale, frame:item})
          value.preparedUrl = window.URL.createObjectURL(blob)
          input[item.id] = value
        }
        break
      case 'BgSelector': 
        if (item.options.length) {
          input[item.id] = item.options[0].id
        }
        break
      case 'Selector': 
        if (item.options.length) {
          input[item.id] = item.options[0].id
        }
        break
    }
  }
  return {input, template, title}
}

const openDesign = async (zipFile, title) => {
  const zip = await JSZip.loadAsync(zipFile)
  const exts = zip.folder('externals')
  const meta = await zip.file('meta.json').async("string").then(s => JSON.parse(s))
  const input = await zip.file('input.json').async("string").then(s => JSON.parse(s))
  const template = await loadTemplate(meta.template, meta.revision)

  for (let p in input) {
    const item = findByProp("id", p, template.items)
    const value = input[p]
    switch (item.type) {
      case 'Picture': 
        if (value.url) {
          const [_ext, i] = value.url.split(':')
          const blob = await exts.file(i).async("blob")
          value.url = window.URL.createObjectURL(blob)
        }
        if (value.preparedUrl) {
          const [_ext, i] = value.preparedUrl.split(':')
          const blob = await exts.file(i).async("blob")
          value.preparedUrl = window.URL.createObjectURL(blob)
        }
        break
      case 'Text': 
        if (value.preparedUrl) {
          const [_ext, i] = value.preparedUrl.split(':')
          const blob = await exts.file(i).async("blob")
          value.preparedUrl = window.URL.createObjectURL(blob)
        }
        break
    }
  }

  return {template, input, title}
}

const onDesignerCreate = (el) => {
  document.documentElement.classList.add('rd-x-suspended')
  tnOnCreate(el)
}
const onDesignerRemove = (el, done) => {
  const myDone = () => {
    document.documentElement.classList.remove('rd-x-suspended')
    done()
  }
  tnOnRemove(el, myDone)
}

const view = (state, actions) => {
  return (
    <form class="rd-Form">
      {state.template ? (
        <div class="rd--designer" oncreate={onDesignerCreate} onremove={onDesignerRemove} key="designer">
          <div class="rd--header" key="designer-header">
            <div class="rd--menu">
              {/* <MenuButton type="normal" onclick={actions.onMenuOpen} title={_T('Menu')} icon="menu" /> */}
            </div>
            <div class="rd--title">
              {/* <TextInput size="full" name="title" value={state.title} oninput={actions.onInputT} onblur={actions.onBlurT} xclass="rd-for-title" /> */}
            </div>
            <div class="rd--controls">
              {/* <MenuButton type="normal" onclick={actions.onDownload} disabled={!state.template.general.excel} xclass="rd-for-download" label={_T('Excel for inputting')} />
              <MenuButton type="primary" onclick={actions.onSave} xclass="rd-for-save" label={_T('Save')} /> */}
              <MenuButton type="normal" onclick={actions.onClose} xclass="rd-for-close" label={_T('Close')} icon="no-alt" />
            </div>
          </div>
          <div class="rd--body" key="designer-body">
            <div class="rd--panel">
              {state.template.items.map((item, i) => {
                switch (item.type) {
                  case 'BgSelector': 
                    return (
                      <BgSelector item={item} value={state.input[item.id]} labels={state.labels} message={state.messages[item.id]} onstart={actions.onBgImageModalActivate} />
                    )
                  case 'Selector': 
                    return (
                      <Selector item={item} value={state.input[item.id]} labels={state.labels} message={state.messages[item.id]} onchange={actions.onChange} />
                    )
                  case 'Picture': 
                    return (
                      <Picture item={item} value={state.input[item.id]} labels={state.labels} message={state.messages[item.id]} onchange={actions.onFileChange} ondrop={actions.onFileDrop} onclear={actions.onFileClear} onadjust={actions.onFileAdjust} />
                    )
                  case 'Text': 
                    return (
                      <Text item={item} value={state.input[item.id]} labels={state.labels} message={state.messages[item.id]} ontextinput={actions.onInput2} ontextblur={actions.onBlur2} onsizechange={actions.onChange2} oncolorchange={actions.onColorChange2} sizes={sizes} />
                    )
                }
              })}
              <Control id="global-save" name={_T('Temporary Save')} note={_Tv('A zip file will be saved in the download folder.')} xclass="rd-for-save" onremove={tnOnRemove}>
                <MiniControl name={_T('File Name')}>
                  <TextInput size="full" name="title" value={state.title} oninput={actions.onInputT} onblur={actions.onBlurT} />
                </MiniControl>
                <Button type="normal" onclick={actions.onSave}>{_T('Save')}</Button>
              </Control>
              <Control id="global-download" name={_T('Excel for inputting')} note={_Tv('A xlsx file will be saved in the download folder.')} xclass="rd-for-download" onremove={tnOnRemove}>
                <Button type="normal" onclick={actions.onDownload} disabled={!state.template.general.excel}>{_T('Download')}</Button>
              </Control>
            </div>
            <div class="rd--model">
              <Model pages={state.pages} pageIndex={state.pageIndex} onnext={actions.onNextPage} onprev={actions.onPrevPage} />
            </div>
          </div>
          <BgImageModal open={!!state.bgImageModalItem} onclose={actions.onBgImageModalClose} onchange={actions.onChange} item={findByProp("id", state.bgImageModalItem, state.template.items)} value={state.input[state.bgImageModalItem]} labels={state.labels} />
          <CropModal open={!!state.cropModalItem} oncancel={actions.onFileCancel} onapply={actions.onPreparePictureK} item={findByProp("id", state.cropModalItem, state.template.items)} value={state.input[state.cropModalItem]} />
          <MenuModal open={state.menuOpen} title={state.title} oninput={actions.onInputT} onblur={actions.onBlurT} ondownload={actions.onDownload} downloadDisabled={!state.template.general.excel} onsave={actions.onSave} onclose={actions.onMenuClose} />
        </div>
      ) : null}
      {/* <InputGroup key="base">
        <Button type="normal" name="2" onclick={actions.onStart}>2を開始</Button>
        <input type="file" onchange={actions.onOpen} />
            </InputGroup> */}
      {/* <div class="rd--preview">
        <textarea value={JSON.stringify(state.input)} ></textarea>
        <textarea value={JSON.stringify(state.pages)} ></textarea>
      </div>
      {template.items.map((item) => {
        const value = state.input[item.id]
        if (! value || ! value.preparedUrl) return null
        return (
          <img key={value.preparedUrl} title={`${item.type}(${item.id})`} src={value.preparedUrl} width={paperWidth} height={paperHeight} style="border:4px solid #333" />
        )
      })} */}
    </form>
  )
}

const catalog = rdData.catalog;
const tnOnRemove = createTnOnRemove(_T('An internal error has occurred. Please reload the page and try again.'));
const noimageUrl = rdData.noimageUrl;
const transparentUrl = rdData.transparentUrl;
const whiteUrl = rdData.whiteUrl;
const refUrl = rdData.refUrl;
const paperWidth = rdData.paperWidth;
const paperHeight = rdData.paperHeight;

const sizes = [
  {name:_T('S'), value:'S'}, 
  {name:_T('MS'), value:'MS'}, 
  {name:_T('M'), value:'M'}, 
  {name:_T('ML'), value:'ML'}, 
  {name:_T('L'), value:'L'}
]

const start = async () => {
  // root
  const form = document.createElement('div')
  form.id = "root"
  document.body.appendChild(form)

  // execute app
  const state = {
    template: null, 
    input: null,  // [itemId]value
    messages: {},  // [itemId]message
    labels: null, 
    pages: null, 
    pageIndex: 0, 
    title: null, 
    bgImageModalItem: null, 
    cropModalItem: null, 
    menuOpen: false
  }
  const allActions = app(state, actions, view, document.getElementById('root'))

  window.setTimeout(() => {
    // file opener
    const openInput = document.getElementById('rakuraku-open-input')
    if (openInput) {
      openInput.addEventListener('change', allActions.onOpen)
    }
    const openLabel = document.getElementById('rakuraku-open-label')
    if (openLabel) {
      openLabel.addEventListener('drop', allActions.onOpen)
      openLabel.addEventListener('dragover', (ev) => {
        ev.preventDefault()
        openLabel.classList.add('rakuraku-is-dragging')
      })
      openLabel.addEventListener('dragleave', (ev) => {
        openLabel.classList.remove('rakuraku-is-dragging')
      })
    }
  
    // buttons to templates
    const buttons = document.querySelectorAll('.rakuraku-new')
    for (let button of buttons) {
      button.addEventListener('click', allActions.onStart)
    }
  }, 100)
}
start()